module.exports = __webpack_public_path__ + "img/15b6cf59c0f5cfdd0268e76f3bcaace4_副本.600d1594.jpg";